import { Tooltip} from '@mantine/core';
import { setclientlanguage} from '../slice/mainslice'
import { useDispatch, useSelector} from 'react-redux'
import intl from "react-intl-universal";

import { notifications } from '@mantine/notifications';

import deflag from '../images/austria-flag-icon.png' 
import enflag from '../images/united-kingdom-flag-icon.png' 

 
/**
 * Renders a component that allows the user to change the client language.
 * 
 * @defvalue {stringt}  - state.user.clientlanguage - default client language
 * @return {JSX.Element} The rendered component.
 */
const ClientChangeLanguage = (props:any) => {
    const dispatch = useDispatch()
    const defvalue = useSelector((state: any) => state.user.clientlanguage)
    const meuser = useSelector((state: any) => state.user.meuser)
 
    /**
     * function that handles the locale change.
     *
     * @param {string} value - the new locale value
     */
    const onLocaleChange = (value:string) => {
        dispatch(setclientlanguage(value));
        notifications.show({
            title: 'Information',
            message: intl.get('CHANGE_LANGUAGE_ALT'),
            withCloseButton: true,
            autoClose: 5000,
          })

         // console.log(props.guestusers)

          const diconnectpayload = {
            ParticipantId: meuser.id,  
          };
          
          if (props.guestusers){
            dispatch({ type: 'SIGNALR_REMOVEPATRICIPANTGUESTFROMCMS', payload: diconnectpayload });
          } else {
            dispatch({ type: 'SIGNALR_REMOVEPATRICIPANTFROMCMS', payload: diconnectpayload });
          }
       


      }


 


      const flagSrc = defvalue === "de_DE" ? enflag : deflag;
      const newLanguage = defvalue === "de_DE" ? "en_US" : "de_DE";
      const flag = (
            <img 
                src={flagSrc} 
                onClick={() => onLocaleChange(newLanguage)} 
                alt={intl.get('CHANGE_LANGUAGE_ALT')}
            />
        );
        
  return (
        <>
         <Tooltip label={intl.get('CHANGE_LANGUAGE_ALT')} >
            {flag}
          </Tooltip>
        </>
    )
    
};

export default ClientChangeLanguage;